const statesArray = [
    {
        text: 'State',
        value: '',
        optionId: '1'
    },
    {
        text: 'Alabama',
        value: 'Alabama',
        optionId: '2'
    },
    {
        text: 'Alaska',
        value: 'Alaska',
        optionId: '3'
    },
    {
        text: 'Arizona',
        value: 'Arizona',
        optionId: '4'
    },
    {
        text: 'Arkansas',
        value: 'Arkansas',
        optionId: '5'
    },
    {
        text: 'California',
        value: 'California',
        optionId: '6'
    },
    {
        text: 'Colorado',
        value: 'Colorado',
        optionId: '7'
    },
    {
        text: 'Connecticut',
        value: 'Connecticut',
        optionId: '8'
    },
    {
        text: 'Delaware',
        value: 'Delaware',
        optionId: '9'
    },
    {
        text: 'District of Columbia',
        value: 'District of Columbia',
        optionId: '10'
    },
    {
        text: 'Florida',
        value: 'Florida',
        optionId: '11'
    },
    {
        text: 'Georgia',
        value: 'Georgia',
        optionId: '12'
    },
    {
        text: 'Hawaii',
        value: 'Hawaii',
        optionId: '13'
    },
    {
        text: 'Idaho',
        value: 'Idaho',
        optionId: '14'
    },
    {
        text: 'Illinois',
        value: 'Illinois',
        optionId: '15'
    },
    {
        text: 'Indiana',
        value: 'Indiana',
        optionId: '16'
    },
    {
        text: 'Iowa',
        value: 'Iowa',
        optionId: '17'
    },
    {
        text: 'Kansas',
        value: 'Kansas',
        optionId: '18'
    },
    {
        text: 'Kentucky',
        value: 'Kentucky',
        optionId: '19'
    },
    {
        text: 'Louisiana',
        value: 'Louisiana',
        optionId: '20'
    },
    {
        text: 'Maine',
        value: 'Maine',
        optionId: '21'
    },
    {
        text: 'Maryland',
        value: 'Maryland',
        optionId: '22'
    },
    {
        text: 'Massachusetts',
        value: 'Massachusetts',
        optionId: '23'
    },
    {
        text: 'Michigan',
        value: 'Michigan',
        optionId: '24'
    },
    {
        text: 'Minnesota',
        value: 'Minnesota',
        optionId: '25'
    },
    {
        text: 'Mississippi',
        value: 'Mississippi',
        optionId: '26'
    },
    {
        text: 'Missouri',
        value: 'Missouri',
        optionId: '27'
    },
    {
        text: 'Montana',
        value: 'Montana',
        optionId: '28'
    },
    {
        text: 'Nebraska',
        value: 'Nebraska',
        optionId: '29'
    },
    {
        text: 'Nevada',
        value: 'Nevada',
        optionId: '30'
    },
    {
        text: 'New Hampshire',
        value: 'New Hampshire',
        optionId: '31'
    },
    {
        text: 'New Jersey',
        value: 'New Jersey',
        optionId: '32'
    },
    {
        text: 'New Mexico',
        value: 'New Mexico',
        optionId: '33'
    },
    {
        text: 'New York',
        value: 'New York',
        optionId: '34'
    },
    {
        text: 'North Carolina',
        value: 'North Carolina',
        optionId: '35'
    },
    {
        text: 'North Dakota',
        value: 'North Dakota',
        optionId: '36'
    },
    {
        text: 'Ohio',
        value: 'Ohio',
        optionId: '37'
    },
    {
        text: 'Oklahoma',
        value: 'Oklahoma',
        optionId: '38'
    },
    {
        text: 'Oregon',
        value: 'Oregon',
        optionId: '39'
    },
    {
        text: 'Pennsylvania',
        value: 'Pennsylvania',
        optionId: '40'
    },
    {
        text: 'Rhode Island',
        value: 'Rhode Island',
        optionId: '41'
    },
    {
        text: 'South Carolina',
        value: 'South Carolina',
        optionId: '42'
    },
    {
        text: 'South Dakota',
        value: 'South Dakota',
        optionId: '43'
    },
    {
        text: 'Tennessee',
        value: 'Tennessee',
        optionId: '44'
    },
    {
        text: 'Texas',
        value: 'Texas',
        optionId: '45'
    },
    {
        text: 'Utah',
        value: 'Utah',
        optionId: '46'
    },
    {
        text: 'Vermont',
        value: 'Vermont',
        optionId: '47'
    },
    {
        text: 'Virginia',
        value: 'Virginia',
        optionId: '48'
    },
    {
        text: 'Washington',
        value: 'Washington',
        optionId: '49'
    },
    {
        text: 'West Virginia',
        value: 'West Virginia',
        optionId: '50'
    },
    {
        text: 'Wisconsin',
        value: 'Wisconsin',
        optionId: '51'
    },
    {
        text: 'Wyoming',
        value: 'Wyoming',
        optionId: '52'
    }
];

export default statesArray;
